import { Component, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-reactive-modal',
  templateUrl: './reactive-modal.component.html',
  styleUrls: ['./reactive-modal.component.scss']
})
export class ReactiveModalComponent implements OnInit {
  itemId?: number;
  public event: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
  }

  onReactiveEvent(id) {
    this.event.emit(id);
  }

}


